import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

import CloningStatusLabel from '../status/CloningStatusLabel'
import SessionName from './SessionName'
import { selectCloneLeaguesSessions, selectCustomerDateFormat } from '../../reducers/clone_leagues_sessions'
import { getDateOnlyUnixFormat } from 'Shared/date_time_format'

const SessionsTable = () => {
  const sessions = useSelector(selectCloneLeaguesSessions)
  const customerDateFormat = useSelector(selectCustomerDateFormat)
  const formatDate = (isoDateString) => isoDateString ? moment(isoDateString).format(getDateOnlyUnixFormat(customerDateFormat)) : ''

  return (<div className="cls-table-container">
    <table className="cls-table">
      <thead>
      <tr>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.session_name')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.date')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.number_of_leagues')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.status')}
        </th>
      </tr>
      </thead>
      <tbody>
      {sessions.map(session => (
        <tr key={session.id}>
          <td className="cls-table-data">
            <SessionName session={session}/>
          </td>
          <td className="cls-table-data">{formatDate(session.created_at)}</td>
          <td className="cls-table-data">{Object.keys(session?.data?.leagues ?? {}).length}</td>
          <td className="cls-table-data">
            <CloningStatusLabel
              status={session.status}
            />
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  </div>)
}

export default SessionsTable
